import React,{useState,useEffect} from "react";
import DeskTopMenu from "./DesktopMenu";
import NonDesktopMenu from "./NonDesktopMenu";
import {ScreenOriantation, ScreenType} from "../../../utils/detectScreen";
//import {connect} from 'react-redux';
const  Menu = (props) =>{
  //const [mainNav, setMainna] = useState([]);
 let deviceOriantation = ScreenOriantation()
 let deviceType =  ScreenType();
/*  window.addEventListener('orientationchange', function(){
  //debugger;
  //console.log(window.orientation);
  if(window.orientation !== 0 ){
      return <DeskTopMenu {...props}/>
  } else  {
    return <NonDesktopMenu {...props}/>
  }
 }, false);  */
  //console.log("menu props....................................."+props);
  /* if(props.deviceWidth > 812) return <DeskTopMenu {...props}/>
  else return <NonDesktopMenu {...props}/> */
  return(
    <>
    <DeskTopMenu {...props}/>
    <NonDesktopMenu {...props}/>
    </>
  )
/*   else{
    //debugger;
    if(deviceOriantation === "landscape" && deviceType === "lg") return <DeskTopMenu {...props}/>
    else return <NonDesktopMenu {...props}/>
  }  */
  
  


  //return (props.deviceWidth > 812 ? <DeskTopMenu {...props}/>:<NonDesktopMenu {...props}/>)
        
         
    
    

}

export default Menu;